// import "./index.scss";
import React from 'react';
import { Form, Input, Row, Col, Button, message, Icon, Select } from 'antd';
import { getSmsCode, checkPhone } from "../../apis/apis";
import { Link, Redirect } from 'react-router-dom';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};
class Forget extends React.Component {
    state = {
        timer: 0,
        //验证码计时
        defaultTimer: 60,
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    loading: true
                });
                checkPhone(values.phone, values.captcha).then(response => {
                    let data = response.data;
                    if (data.error) {
                        this.setState({
                            msg: data.msg
                        })
                    } else {
                        this.props.history.push({ pathname: '/reset' })
                    }
                }).catch(error => {

                })
            }
        })
    }
    setPhone = (e) => {
        this.setState({
            phone: e.target.value
        })
    }
    getIdenCode = (e, phone) => {
        if (this.state.timer != 0) {
            e.preventDefault();
            return;
        } else {
            if (!phone) {
                this.setState({
                    msg: "请输入手机号"
                });
                return;
            }
            this.setState({
                defaultTimer: 60
            }, () => {
                getSmsCode(phone).then((response) => {
                    let intervalid = window.setInterval(() => {
                        this.setState({
                            timer: this.state.defaultTimer--
                        }, () => {
                            if (this.state.timer === 0) {
                                window.clearInterval(intervalid);
                            }
                        })
                    }, 1000);
                }).catch((error) => {
                    let data = error.response && error.response.data ? error.response.data : { msg: "操作过于频繁，请稍后再试！" };
                    message.error(data.msg);
                });
            })
        }
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const prefixSelector = getFieldDecorator('prefix', {
            initialValue: '86',
        })(
            <Select style={{ width: 70 }}>
                <Select.Option value="86">+86</Select.Option>
            </Select>
        );
        return (
            <Form id="forget" onSubmit={this.handleSubmit}>
                <Form.Item
                    {...formItemLayout}
                    label="手机号"
                >
                    {getFieldDecorator('phone', {
                        rules: [{ required: true, message: '请输入手机号!' }, {
                            pattern: /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/, message: "请输入正确的手机号"
                        }],
                    })(
                        <Input addonBefore={prefixSelector} style={{ width: '100%' }} onChange={this.setPhone} />
                    )}
                </Form.Item>
                <Form.Item
                    {...formItemLayout}
                    label="验证码"
                    extra=""
                >
                    <Row gutter={8}>
                        <Col span={12}>
                            {getFieldDecorator('captcha', {
                                rules: [{ required: true, message: '请输入验证码!' }],
                            })(
                                <Input />
                            )}
                        </Col>
                        <Col span={12}>
                            <Col span={12}>
                                <Button onClick={(e => {
                                    this.getIdenCode(e, this.state.phone)
                                })}>{this.state.timer === 0 ? "获取验证码" : this.state.timer + "s后再次获取"}</Button>
                            </Col>
                        </Col>
                    </Row>
                </Form.Item>
                <Row><Link to="/login" >登录</Link> <Link to="/register" style={{ float: "right" }}>注册</Link></Row>
                <Form.Item>
                    <Button type="primary" size="large" style={{ marginTop: "10px" }} htmlType="submit" block>下一步{this.state.loading ? <Icon type="loading" /> : null}</Button>
                </Form.Item>
                <Row><div className="msg">{this.state.msg}</div></Row>
            </Form>
        );
    }
}

export default Form.create({ name: "forget" })(Forget);